import { useDispatch } from "react-redux";
// import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"

export default function Landing2Apps() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-Apps-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">Passenger App</h4>
                <span>Our user-friendly taxi app is developed and designed to make the booking process effortless and convenient for your customers.</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 order-2 order-lg-1">
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-1.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Quick & Easy Booking</h4>
                  <p>Let customers book rides anytime, anywhere, in seconds—no calls or waiting- ensuring a hassle-free experience.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-2.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Fare Estimates</h4>
                  <p>Provide transparent, upfront fare estimates, giving users peace of mind before confirming their ride with no unexpected charges.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-3.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Real-Time Driver Tracking</h4>
                  <p>Allow passengers to track their driver’s location in real-time, enhancing convenience and safety throughout the journey.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-4.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Multiple Payment Methods</h4>
                  <p>Support payments via cash, credit/debit cards, and digital wallets, ensuring a seamless and flexible payment experience for users.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 order-1 order-lg-2">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-1.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12 order-3 order-lg-3">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area land2-apps-differ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">Driver App</h4>
                <span>Equip your drivers with essential tools to ensure seamless service and increased productivity.</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-2.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-5">
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-1.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Trip Requests</h4>
                  <p>Receive ride requests instantly, with an option to accept or decline in one tap for quick decision-making.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-2.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Built-in Navigation Support</h4>
                  <p>Integrated GPS and real-time traffic updates guide drivers to destinations efficiently and minimize delays.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-3.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Earnings Tracking</h4>
                  <p>Monitor daily earnings, completed trips, bonuses, and performance data on an intuitive, clean dashboard.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-4.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Identity Verification</h4>
                  <p>Drivers can have their documents verified by the admin via email or SMS for identity confirmation.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">Admin Dashboard</h4>
                <span>A comprehensive control panel designed to oversee all aspects of your taxi operations with precision and real-time insights.</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 order-2 order-lg-1">
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-5.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Real-Time Monitoring</h4>
                  <p>Monitor ride activities, driver availability, and ongoing trips in real-time to ensure operational efficiency and service reliability.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-6.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Detailed Reports & Analytics</h4>
                  <p>Access comprehensive data on trip history, driver earnings, fleet performance, and customer trends to improve taxi business decisions.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-7.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>User & Fleet Management</h4>
                  <p>Easily add or remove drivers, manage vehicle details, assign service zones, and update pricing rules—all from a single, centralized platform.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-8.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Corporate Console and fleet management system</h4>
                  <p>The Corporate Console and fleet management system enable businesses to manage profiles, create employee trips, set fares, and assign drivers. Corporates can also add, manage, and remove employees, streamlining fleet operations and enhancing control.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 order-1 order-lg-2">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-3.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12 order-3 order-lg-3">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area land2-apps-differ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">Dispatcher Panel</h4>
                <span>Empower your dispatch team with a powerful panel to manage bookings efficiently, assign rides, and support customers instantly.</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-4.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-5">
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-9.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Manual Ride Assignment</h4>
                  <p>Easily assign rides to available drivers, effectively ensuring immediate service for phone bookings, urgent requests, or high-priority VIP clients.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-10.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Live Fleet Overview</h4>
                  <p>Track available, active, or offline drivers in real time to manage fleet operations efficiently and respond quickly to service changes.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-3.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Automated dispatch</h4>
                  <p>Automated dispatching streamlines operations by automatically assigning tasks to drivers, ensuring quick, precise, and cost-effective service delivery.</p>
                </div>
              </div>
              <div className="land2-app-box">
                <img loading="lazy" src="/assets/home/land2-app-logo-11.webp" alt="icon" className="img-responsive" />
                <div>
                  <h4>Efficient dispatching</h4>
                  <p>Efficient dispatching optimizes route assignments, reducing delays and maximizing fleet productivity for faster, reliable service.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
